import { render, staticRenderFns } from "./WContainer.vue?vue&type=template&id=2ebbb2b6&scoped=true&"
import script from "./WContainer.vue?vue&type=script&lang=js&"
export * from "./WContainer.vue?vue&type=script&lang=js&"
import style0 from "./WContainer.vue?vue&type=style&index=0&id=2ebbb2b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbb2b6",
  null
  
)

export default component.exports